import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Message } from 'botframework-directlinejs';

import { hashMerge } from './utilites';

export interface Feedback02Props {
    message: Message;
    candidates: string[];
    onCardAction: (type: string, value: string) => void;
    userDefined: any;
}

export interface Feedback02State {
    currentState: string;
    commentVisible: boolean;
    comment: string;
    expectedAnswer: string;
    eval: number;
    sent: boolean;
    feedbackEntitiy: any;
    options: any;
    stopAfterSelectGood: boolean;
    stopAfterSelectBad: boolean;
}

export class Feedback02View extends React.Component<Feedback02Props, Feedback02State> {

    private strings : {
        firstMsg : string,
        goodMsg : string,
        badMsg : string
    }

    constructor(props: Feedback02Props) {
        super(props);

        this.strings = {
            firstMsg : "ご案内はお役に立ちましたか？",
            goodMsg : "ありがとうございます！お役に立てて嬉しいです。",
            badMsg : "大変申し訳ありません。お役に立てるよう努力します。"
        };

        if (this.props.userDefined.strings) {
            this.strings = hashMerge(this.strings, this.props.userDefined.strings);
        }

        this.state = {
            currentState : "wait",
            commentVisible : true, //初期フィードバック　開閉
            comment : "",
            expectedAnswer : "",
            eval : 0,
            sent : false,
            feedbackEntitiy : (this.props.message.entities || []).find((x) => x.feedback),
            options : this.props.candidates.map((row, i) => <option value={row} key={"candidates" + i}>{i + 1}.{row}</option>), //意図リスト
            stopAfterSelectGood : false,
            stopAfterSelectBad : false
        };
    }

    // 有人チャット遷移
    decisionEscalation = () => {
        let that = this;
        let escalationInfoEntitiy;
        let value: string;
        //cookie取得
        var r = document.cookie.split(';');
        r.forEach(function(values){
            //cookie名と値に分ける
            var content = values.split('=');
            if(content[0].trim() == "escalationInfoEntitiy"){
                escalationInfoEntitiy = JSON.parse(decodeURIComponent(content[1]) || "{}");
                if(escalationInfoEntitiy.feedback){
                    value = JSON.stringify({
                        "cmd": "guideToRightNow",
                        "value": "feedback"
                    });
                }
            }
        })
        if (value){
            let contactID: string;
            //cookie取得
            var r = document.cookie.split(';');
            r.forEach(function(values:string){
                //cookie名と値に分ける
                var content = values.split('=');
                if(content[0].trim() == "escalationInfoEntitiy"){
                    contactID = JSON.parse(decodeURIComponent(content[1]) || "{}").contactID;
                }
            })
            if(contactID){
                //大塚ログイン状況取得
                var Promise1 = new Promise (function ( resolve, reject ) {
                    let otsuuLoginStateRequestURL = "https://mypage.otsuka-shokai.co.jp/GetLoginUserInfo";
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", otsuuLoginStateRequestURL, true);
                    xhr.send(null);
                    xhr.onerror = function(){
                        document.cookie = "otsuuLoginState=false";
                        resolve();
                    };
                    xhr.onload = function(){
                        if (xhr.readyState == 4 && xhr.status == 200) {
                            let data:any = JSON.parse(xhr.responseText);
                            //ログイン状況をセッションに保存
                            if(data.result == "0"){
                                document.cookie = "otsuuLoginState=true";
                            }else{
                                document.cookie = "otsuuLoginState=false";
                            }
                            resolve();
                        }
                    };
                });
                //有人チャット対応可能人数取得
                var Promise2 = new Promise (function ( resolve, reject ) {
                    let interPersonalChatStatusRequestURL = "https://bcvipjp02.rightnowtech.com/Chat/chat/otsuka_shokai__tst1?";
                    let queue_id = "queue_id=" + contactID;
                    let option ="&pool=6603:4&action=PROACTIVE_QUERY&avail_type=agents&p_db_name=otsuka_shokai__pro&p_intf_id=1&responseType=JSON&callback=rntJSONspac_0";
                    var xhrc = new XMLHttpRequest();
                    xhrc.open("GET", interPersonalChatStatusRequestURL + queue_id + option, true);
                    xhrc.send(null);
                    xhrc.onerror = function(){
                        document.cookie = "interPersonalChatStatus=false";
                        resolve();
                    };
                    xhrc.onload = function(){
                        if (xhrc.readyState == 4 && xhrc.status == 200) {
                            let tmpXhrc:any = xhrc;
                            var data =  JSON.parse(tmpXhrc.responseText.match("\{.+?\}"))
                            if(data.availableAgentSessions > 0){
                                document.cookie = "interPersonalChatStatus=true";
                            }else{
                                document.cookie = "interPersonalChatStatus=false";
                            }
                            resolve();
                        }
                    };
                });
                Promise.all( [Promise1, Promise2] ).then(function(){
                    //cookie情報取得
                    let interPersonalChatStatus = false;
                    var r = document.cookie.split(';');
                    r.forEach(function(value){
                        //cookie名と値に分ける
                        var content = value.split('=');
                        if(content[0].trim() == "interPersonalChatStatus"){
                            interPersonalChatStatus = (decodeURIComponent(content[1]).toLowerCase() == "true") ? true : false;
                        }
                    });
                    if(interPersonalChatStatus){
                        that.props.onCardAction("postBack", value);
                    }
                });
            }
        }
    };

    changeExpectedAnswer(e:any) {
        let value = e.target.value.replace(/(^[\s　]|[\s　]$)/g, "");
        if (value) {
            this.setState({ expectedAnswer : value });
            this.setState({ options : this.props.candidates.map((row, i) => <option value={row} key={"candidates" + i}>{i + 1}.{row}</option>) });
        } else {
            this.setState({ expectedAnswer : "" });
            this.setState({ options : this.props.candidates.map((row, i) => <option value={row} key={"candidates" + i}>{i + 1}.{row}</option>) });
        }
    }

   // コメント入力欄のステータス切り替え
    showMessagePane = () => {
        this.setState({ commentVisible : !this.state.commentVisible });
    }

    // コメント送信
    sendComment = () => {
        let value = JSON.stringify(
            {
                "cmd": "feedback",
                "key": (this.props.message.entities || []).find((x:any) => x.feedback).feedback,
                "comment": this.state.comment,
                "value": this.state.eval,
                "expectedAnswer": this.state.expectedAnswer
            });

        this.setState({
            sent : true,
            commentVisible : false,
            currentState : "send-comment"
        });

        this.props.onCardAction("postBack", value);
        this.decisionEscalation();
    };

    componentDidMount() {
        if (this.props.userDefined.enable && this.props.userDefined.init) {
            this.props.userDefined.init({
                element : ReactDOM.findDOMNode(this),
                onCardAction : this.props.onCardAction,
                status : this.state
            });
        }
    }

    render() {
        return (
            <div className='osk-feedback'>
                { !this.state.sent ? (
                <div>
                    <p>{ this.strings.firstMsg }</p>
                    <button
                        type="button"
                        className="osk-comment"
                        onClick={ this.showMessagePane }>フィードバック{ this.state.commentVisible ? "を閉じる" : "" }</button>

                    { this.state.commentVisible ?
                    <div className="osk-feedback-comment" >
                        <table>
                            <tbody>
                                <tr className="osk-row">
                                    <th>
                                        <label htmlFor={ "expected-answer-" + this.props.message.id }>自分が担当した質問</label>
                                    </th>
                                    <td>
                                        <div className="input-type-select">
                                            <select
                                                id={ "expected-answer-" + this.props.message.id }
                                                className={ !this.state.expectedAnswer ? "invalid" : "" }
                                                onChange={ (e:any) => { this.changeExpectedAnswer(e); } }
                                                value={ this.state.expectedAnswer }>
                                                <option value="">選択してください</option>
                                                { this.state.options }
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="osk-row">
                                    <th>
                                        <label>評価</label>
                                    </th>
                                    <td>
                                        <ul className="radio-buttons">
                                            <li><input
                                                type="radio"
                                                name="eval"
                                                value="1"
                                                id={ "eval-good-" + this.props.message.id }
                                                className={ this.state.eval === 0 ? "invalid" : "" }
                                                onChange={ () => this.setState({eval : 1}) }
                                                checked={ this.state.eval === 1 } />
                                            <label htmlFor={ "eval-good-" + this.props.message.id }>質問に対する回答が得られた-Good</label></li>
                                            <li><input
                                                type="radio"
                                                name="eval"
                                                value="-1"
                                                id={ "eval-bad-" + this.props.message.id }
                                                className={ this.state.eval === 0 ? "invalid" : "" }
                                                onChange={ () => this.setState({eval : -1}) }
                                                checked={ this.state.eval === -1 } />
                                                <label htmlFor={ "eval-bad-" + this.props.message.id }>質問に対する回答が得られなかった-Bad</label></li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr className="osk-row">
                                    <th>
                                        <label htmlFor={ "comment-" + this.props.message.id }>コメント</label>
                                    </th>
                                    <td><textarea
                                            id={ "comment-" + this.props.message.id }
                                            onChange={(e:any) => { this.setState({ comment: e.target.value }) }}
                                            value={ this.state.comment }></textarea></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="osk-row">
                            <button
                                type="button"
                                onClick={ this.sendComment }
                                disabled={ !this.state.expectedAnswer || this.state.eval === 0 }>送信</button>
                        </div>
                    </div> : null }
                </div>) : <p>フィードバックは無事送信されました。</p> }
            </div>
        );
   }
}


// WEBPACK FOOTER //
// ./src/Feedback02.tsx